module.exports = __webpack_public_path__ + "static/media/zoom.2530eadc.png";